import { fetchCanonicalMessages } from '../../../components/messaging/canonicalMessagingApi';
export async function localSystemTimeline(conversationId, enabled, audience, read = fetchCanonicalMessages) {
  if (!enabled || audience !== 'customer') return [];
  try {
    const page = await read(conversationId, { read_source: 'local', limit: 50 }, { silent: true });
    return (page.items || []).filter(item => item.content?.kind === 'system');
  } catch { return []; } // Compatibility history remains usable; no local error banner.
}
export function mergeSystemTimeline(base, local) {
  const rows = new Map(base.map(item => [item.id, item]));
  local.forEach(item => { if (!rows.has(item.id)) rows.set(item.id, item); });
  const timestamp = item => Date.parse(item.created_at || item.occurred_at || '') || 0;
  return [...rows.values()].sort((a, b) => timestamp(a) - timestamp(b) || String(a.id).localeCompare(String(b.id)));
}
